import { defineStore } from "pinia";
import axios from "axios";
import { useRouter} from "vue-router";
import { useToasts } from "@/stores/Toasts";
import ErrorMessageParser from "@/scripts/parsers/ErrorMessageParser";
export const useRequests = defineStore("Requests", {
  state() {
    return {
      loading: false,
      toasts: useToasts(),
      location_url:"",
      location_origin:"",
      location_pathname:"",
     
    };
  },

  actions: {
    post(requestdata) {
      this.loading = true;
      this.toasts.display = false;
      return new Promise((resolve, reject) => {
        axios
          .post(requestdata.url, requestdata.data, {})
          .then((response) => {
            resolve(response);
            this.loading = false;
          })
          .catch((error) => {
            reject(error);
            console.log(error)
            this.loading = false;
            this.toasts.setErrorMessage(ErrorMessageParser(error));

            if (
              error.response.status === 401 ||
              error.response.data.message === "401 Unauthorized"
            ) {
              useRouter().push("/");
            }
          });
      });
    },
    get(requestdata) {
      this.loading = true;
      this.toasts.display = false;
      return new Promise((resolve, reject) => {
        axios
          .get(requestdata.url, requestdata.data, {})
          .then((response) => {
            resolve(response);
            this.loading = false;
          })
          .catch((error) => {
            reject(error);
            this.loading = false;
            this.toasts.setErrorMessage(ErrorMessageParser(error));

            if (
              error.response.status === 401 ||
              error.response.data.message === "401 Unauthorized"
            ) {
              useRouter().push("/");
            }
          });
      });
    },
  },
});
